// 当前运行环境
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

// 登录站点域名
export const LOGIN_HOST = process.env.REACT_APP_LOGIN_HOST;

export const SERVICE_SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

//当前域名
export const HOST = process.env.REACT_APP_HOST;
